import React, { useEffect, useState } from "react";
import { Container, Typography } from "@mui/material";

import {
  findGetParameter,
  getData,
} from "../../components/utilities/UtilityFunctions";
import {
  getRegionsArray,
  getGlobalRegion,
} from "../../components/api/APIUtilities";

import ModalLoadingFull from "../../components/modals/ModalLoadingFull";
import RankingsWidgetRegional from "../../components/rankings/RankingsWidgetRegional";
import { useParams } from "react-router";

const globalRegion = getGlobalRegion();

export default function TeamRankings(props) {
  const { regionId, appRoute } = props;
  let { leagueId } = useParams();
  const leagueIdParam = findGetParameter("league");
  const regionIdParam = findGetParameter("region");
  const embed = appRoute || findGetParameter("embed") === "true";

  const [loading, setLoading] = useState(true);
  const [league, setLeague] = useState(null);
  const [regions, setRegions] = useState(null);

  useEffect(() => {
    const go = async () => {
      // call api instead
      var apiLeague = await getData(
        `/leagues/${leagueId || leagueIdParam || props.leagueId}`,
        {
          queryStringParameters: {
            "expand[]": ["gameSystem", "gameStoreUser"],
          },
        }
      );

      var apiRegions = await getData(`/leagues/${apiLeague.id}/regions`);
      let _regions = [];
      if (!apiRegions?.length) {
        _regions = getRegionsArray();
      } else if (apiRegions?.length === 1) {
        _regions = apiLeague.gw_itc
          ? [
              ...apiRegions[0]?.children,
              { id: apiRegions[0].id, name: apiRegions[0].name },
            ]
          : [
              { id: apiRegions[0].id, name: apiRegions[0].name },
              ...apiRegions[0]?.children,
            ];
      } else {
        _regions = apiLeague.gw_itc
          ? apiRegions.sort((a, b) => {
              if (a.id === globalRegion.id) return 1;
              if (b.id === globalRegion.id) return -1;
              return 0;
            })
          : apiRegions;
      }

      setRegions(_regions);

      apiLeague.teams = true;

      setLeague(apiLeague);

      setLoading(false);
    };

    go();
    // eslint-disable-next-line
  }, []);

  return (
    <>
      {loading && <ModalLoadingFull />}
      {!loading && (
        <Container sx={{ pt: 2, pb: 2, textAlign: "center" }} maxWidth="lg">
          <Typography variant="h1" gutterBottom>
            Team Rankings
          </Typography>
          <RankingsWidgetRegional
            rankingGroup={league}
            leagueId={leagueId || leagueIdParam || props.leagueId}
            regionId={regionId || regionIdParam}
            regions={regions}
            doSearch
            doPages
            rowsPerPage={50}
            rowsPerPageArray={[25, 50, 100, { label: "All", value: -1 }]}
            embed={embed}
          />
        </Container>
      )}
    </>
  );
}
